import React from "react";
import { toast } from "react-toastify";

import { useAuth } from "../../Contexts/AuthContext";
import supabase from "../../utils/subabaseClient";

export default function Logout() {
  const [loading, setLoading] = React.useState(false);
  const { logout } = useAuth();

  const handleLogout = () => {
    setLoading(true);
    supabase.auth
      .signOut()
      .then(() => {
        logout();
        toast.success("Logged out successfully");
        window.location.href = "/login";
      })
      .catch((error) => {
        toast.error(error.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <div className="text-center">
      <h5 className="mt-4">Are you sure you want to logout?</h5>
      <button
        className="btn btn-primary mt-4"
        onClick={handleLogout}
        disabled={loading}
      >
        Yes
      </button>
    </div>
  );
}
